import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowRight, HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import FeaturedIcon from "@/components/atoms/FeaturedIcon";

const ListNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-grow flex-col items-center justify-center">
      <FeaturedIcon icon={HiOutlineDocumentMagnifyingGlass} size={"lg"} color={"error"} />
      <div className="mt-4 max-w-sm text-center">
        <h1 className="text-xl font-semibold text-primary">{t("static.listNotFound.title")}</h1>
        <p className="mt-1 text-sm text-tertiary">{t("static.listNotFound.text")}</p>
        <Button
          label={t("static.listNotFound.button")}
          onClick={() => navigate(routes.lists)}
          trailingIcon={<HiOutlineArrowRight className={"size-4"} />}
          className={"mt-4"}
        />
      </div>
    </div>
  );
};

export default ListNotFound;
